import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translation files
import enTranslations from './locales/en.json';
import elTranslations from './locales/el.json';

// Get saved language from localStorage or default to Greek
const savedLanguage = localStorage.getItem('language') || 'el';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslations },
      el: { translation: elTranslations }
    },
    lng: savedLanguage,
    fallbackLng: 'el',
    interpolation: {
      escapeValue: false // React already prevents xss
    }
  });

export default i18n;
